import * as React from 'react';
import { Grid, Paper, Tab, Tabs } from '@material-ui/core';
import Canvas from '../canvas/Canvas';
import { _PortalState } from '../../helpers/state';
import { InnovationDashBoard } from './InnovationDashboard';
import { useTeams } from 'msteams-react-base-component';

export const Innovation: React.FC<InnovationProps> = (props: InnovationProps) => {

    // const GroupId = _PortalState.teamsContext.groupId

    const [selectedTab, SetselectedTab] = React.useState<number>(0);
    const [{ inTeams, theme, context }] = useTeams();

    
    return (
        <div style={{ width: '99%' }}>
            {/* <Grid container={true} justify="center" spacing={3}> */}
            <Paper>
                <Tabs
                    value={selectedTab}
                    variant="fullWidth"
                    onChange={((event: React.ChangeEvent<{}>, value: any) => {
                        // console.log(value);
                        SetselectedTab(value);
                    })}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Canvas" />
                    <Tab label="Experiments" />
                    {/* <Tab label="Experiments" /> */}
                    {/* <Tab label="Customers" /> */}

                </Tabs>
            </Paper>
            {/* </Grid> */}
            <div style={{ padding: '30px 0 0 0' }}>
                {selectedTab === 1 &&
                    <InnovationDashBoard key={(props as any)['match'].params.group} groupid={(props as any)['match'].params.group} />
                }
                {
                    selectedTab === 0 &&
                    <Canvas key={(props as any)['match'].params.group} />
                }
            </div>

        </div>
    )


}

interface InnovationProps {

}